import Box from '@/components/UI/box/Box';
import styles from './MidTermFactor.module.scss';
import Typography from '@/components/UI/typography/Typography';
import ConditionalRenderer from '@/components/reusable/ConditionalRenderer';
import { currencyHandler } from '@/helpers/currencyHandler';
import Spinner from '@/components/UI/spinner/Spinner';
import { useRef, useState } from 'react';
import Icon from '@/components/UI/icon/Icon';
const titleHandler = data => {
  if (data.key === 'day') {
    return `${data.count} شب`;
  } else if (data.key === 'extra_person') {
    return `${data.count} نفر اضافه`;
  } else {
    return data.title;
  }
};
const DiscountList = ['discount_days', 'discount_late_night', 'daily_discount'];
const MidTermFactor = ({
  proformaState
}) => {
  const [expanded, setExpanded] = useState(false);
  const listRef = useRef<HTMLDivElement | null>(null);
  const data = proformaState?.data ? [...(proformaState.data?.days || []), ...(proformaState.data?.details || [])] : [];
  const totalPrice = proformaState?.data?.total_payable_amount;
  const totalDiscount = proformaState?.data?.total_discount;
  const totalWithoutDiscount = proformaState?.data?.total_without_discount;
  return <Box className={styles['mid-term-factor-container']} data-sentry-element="Box" data-sentry-component="MidTermFactor" data-sentry-source-file="MidTermFactor.tsx">
      <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="MidTermFactor.tsx">صورت‌حساب</Typography>
      {proformaState?.loading ? <Box className={styles['circular-progress']}>
          <Spinner color="primary_main" />
        </Box> : <Box className={styles['factor-detail-container']} id="factor-detail-container">
          <Box className={styles['factor-detail-list-container']}>
            <Box ref={listRef} className={styles['factor-detail-list'] + ' ' + `${expanded ? styles['extended'] : ''}`} style={{
          maxHeight: expanded ? listRef.current?.scrollHeight : 0
        }}>
              {data?.map((item, index) => item?.final_price > 0 && item?.count !== 0 && <Box className={styles['factor-detail-item'] + ' ' + `${DiscountList.includes(item.key) ? styles['discount'] : ''}`} key={'FACTOR_DETAIL_ITEM_' + index}>
                      <Box className={styles['row-title']}>
                        <Typography variant="bodyS">
                          {titleHandler(item)}
                        </Typography>
                        <ConditionalRenderer condition={item.key === 'day'}>
                          <>
                            <Typography variant="bodyS">x</Typography>
                            <Typography variant="bodyS">
                              {currencyHandler(item.unit_price)} تومان{' '}
                            </Typography>
                          </>
                        </ConditionalRenderer>
                      </Box>
                      <Typography variant="bodyS">
                        {currencyHandler(item?.final_price || 0)}{' '}
                        <Typography variant="bodyS">تومان</Typography>
                      </Typography>
                    </Box>)}
            </Box>
            <Box className={styles['factor-summery'] + ' ' + `${!expanded ? styles['extended'] : ''}`}>
              <Box className={styles['factor-detail-item']}>
                <Typography variant="bodyM" className={styles['row-title']}>
                  مبلغ کل رزرو
                </Typography>
                <Typography variant="bodyM" className={styles['row-title']}>
                  {currencyHandler(totalWithoutDiscount?.final_price || 0)}{' '}
                  <Typography variant="bodyM" className={styles['discount-toman-value']}>
                    تومان
                  </Typography>
                </Typography>
              </Box>
              <Box className={styles['factor-detail-item'] + ' ' + styles['discount']}>
                <Typography variant="bodyM" className={styles['row-title']}>
                  تخفیف
                </Typography>
                <Typography variant="bodyM" className={styles['discount-value']}>
                  {currencyHandler(totalDiscount?.final_price || 0)}{' '}
                  <Typography variant="bodyM" className={styles['discount-toman-value']}>
                    تومان
                  </Typography>
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box className={styles['factor-detail-final-price']}>
            <Typography variant="bodyM_Bold" className={styles['final-price-title']}>
              مبلغ کل رزرو
            </Typography>
            <Typography variant="bodyM_Bold" className={styles['final-price-cost-value']}>
              {currencyHandler(totalPrice?.final_price || 0)}{' '}
              <Typography variant="bodyM" className={styles['final-price-currancy']}>
                تومان
              </Typography>
            </Typography>
          </Box>
          <Box className={styles['see-more-container']} onClick={() => setExpanded(prev => !prev)}>
            <Typography variant="bodyS" className={styles['see-more-button']}>
              {expanded ? 'بستن جزئیات' : 'مشاهده جزئیات'}
            </Typography>
            <Icon name={expanded ? 'arrow-up-1' : 'arrow-down-1'} type="primary" />
          </Box>
        </Box>}
    </Box>;
};
export default MidTermFactor;